import { useState } from "react";
import { Play, Youtube } from "lucide-react";
import { Reveal } from "./lib";

// Placeholder videos from Applied Materials' official YouTube channel
export const VIDEOS = {
  highlights: { id: "YxOGoO_uf8A", title: "How does Applied Materials lead the way in powering sustainable growth?" },
  people: { id: "jOcN2giPLEE", title: "Deliver Material Innovation at Applied Materials" },
  planet: { id: "ELxOmfkZtzQ", title: "Explain2Me: Semiconductors and Sustainability" },
};

type Video = { id: string; title: string };

function Player({ video, testId }: { video: Video; testId: string }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="am-clip relative aspect-video overflow-hidden bg-[#1e3442]" data-testid={`${testId}-player`}>
      {playing ? (
        <iframe className="absolute inset-0 h-full w-full" src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0`}
          title={video.title} allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen />
      ) : (
        <button type="button" onClick={() => setPlaying(true)} className="am-video-btn group absolute inset-0 h-full w-full" data-testid={`${testId}-play`}>
          <img src={`/amat/video/${video.id}.jpg`} alt="" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]" loading="lazy" />
          <span className="absolute inset-0 bg-black/20 transition-colors group-hover:bg-black/10" />
          <span className="am-bg-accent absolute left-1/2 top-1/2 grid h-16 w-16 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full text-white shadow-lg transition-transform group-hover:scale-110 sm:h-20 sm:w-20">
            <Play size={28} fill="currentColor" aria-hidden />
          </span>
          <span className="sr-only">Play video: {video.title}</span>
        </button>
      )}
    </div>
  );
}

export function VideoFeature({ video, testId }: { video: Video; testId: string }) {
  return (
    <Reveal className="mt-20 grid items-center gap-6 lg:grid-cols-[1.6fr_1fr] lg:gap-12" testId={testId}>
      <Player video={video} testId={testId} />
      <div className="border-l-4 border-[var(--accent)] pl-5">
        <p className="am-eyebrow am-accent">Video</p>
        <h3 className="mt-3 text-2xl font-semibold leading-snug am-accent sm:text-3xl" data-testid={`${testId}-title`}>{video.title}</h3>
        <a href={`https://www.youtube.com/watch?v=${video.id}`} target="_blank" rel="noreferrer" className="am-chip mt-5" data-testid={`${testId}-source`}>
          <Youtube size={13} aria-hidden /> Applied Materials on YouTube<span className="sr-only"> (opens in a new tab)</span>
        </a>
        <p className="mt-3 text-xs">Placeholder video from Applied Materials’ YouTube channel. Not part of the 2025 Impact Report PDF.</p>
      </div>
    </Reveal>
  );
}
